import { render, staticRenderFns } from "./CampaignImage.vue?vue&type=template&id=e67b8f9e&"
import script from "./CampaignImage.vue?vue&type=script&lang=js&"
export * from "./CampaignImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports